import React from 'react';
import { Grid } from 'react-bootstrap';

import './index.less';

const Header = () => (
  <div className="header">
    <Grid>
      <div className="logo">
        <img src="/logo.svg" alt="logo" />
      </div>
      <h1>
        Зголошення до складу КБ УПЮ<br />
        <small>МРСК | Крайова булава УПЮ</small>
      </h1>
    </Grid>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Main/Header.js